import { Filial } from "../filial/filial";
import { Medico } from "../medico/medico";
import { PlanoSaude } from "../plano-saude/plano-saude";
import { ProcedimentoConsulta } from "../procedimento/procedimento-consulta/procedimento-consulta";
import { AgendaMedicaPlanoSaude } from "./agenda-medica-plano-saude";
import { AgendaMedicaProcedimentoConsulta } from "./agenda-medica-procedimento-consulta";
import { AgendaMedicaPk } from "./pks/agenda-medica-pk";

export class AgendaMedica {

    pk: AgendaMedicaPk = new AgendaMedicaPk();

    filial: Filial = new Filial();

    medico: Medico = new Medico();

    quantidadeAtd: number = 0;

    atdIdadeMinima: number = 0;

    atdIdadeMaxima: number = 0;

    atdPortadorNecessidade: boolean = false;

    listaAgendaMedicaProcedimentoConsulta: Array<AgendaMedicaProcedimentoConsulta> = [];

    listaAgendaMedicaPlanoSaude: Array<AgendaMedicaPlanoSaude> = [];

    dataInicioAgenda: Date = new Date();

    procedimentos: ProcedimentoConsulta[] = [];

    planosDeSaude: PlanoSaude[] = [];

    horaAtendimentoInicial: string = '';

    horaAtendimentoFinal: string = '';

    tempoAtd: number = -1;

    constructor() {
    }
}
